// extracted by mini-css-extract-plugin
export var couponInput = "UniversalCouponInput_couponInput__l1ZBx";
export var couponInputContainer = "UniversalCouponInput_couponInputContainer__39ceq";
export var couponInputInvalid = "UniversalCouponInput_couponInputInvalid__M4bU+";
export var couponInputLabel = "UniversalCouponInput_couponInputLabel__Zx3MP";
export var defaultInputWrapper = "UniversalCouponInput_defaultInputWrapper__4qFbM";
export var discounAndLabel = "UniversalCouponInput_discounAndLabel__LKwtZ";
export var secondaryInputWrapper = "UniversalCouponInput_secondaryInputWrapper__BBruQ";
export var successMessage = "UniversalCouponInput_successMessage__tYvt7";